import { EmptyDescription } from '../empty';

/**
 * A byline used to explain how to resolve an error state. Part of the multipart `Error` component. Composes `Box`.
 */
export const ErrorDescription = EmptyDescription;
ErrorDescription.displayName = 'ErrorDescription';
